import { InvoiceProductTypeModel } from './invoice-product-type.model';
import { TypeTvaModel } from './type-tva.model';
import { TerritoryModel } from './territory.model';
import { ZoneModel } from './zone.model';

export class TypeTvaCompanyTerritoryModel {
  public id: number;
  public label: string = null;
  public codeLlabel: string = null;
  public typeTva: TypeTvaModel = new TypeTvaModel();
  public companyCode: string = null;
  public invoiceProductType: InvoiceProductTypeModel = new InvoiceProductTypeModel();
  public activated: boolean = null;
  public territory: TerritoryModel = new TerritoryModel();
  public zone: ZoneModel = new ZoneModel();

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }

  public fromJSONs(jsons) {
    const refs: TypeTvaCompanyTerritoryModel[] = [];
    jsons.forEach(json => {
      refs.push(new TypeTvaCompanyTerritoryModel().fromJSON(json));
    });
    return refs;
  }
}
